/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ReferencePropertyConfig } from "./ReferencePropertyConfig";
import { BaseProperty } from "./BaseProperty";
import { ArrayableProperty } from "./ArrayableProperty";
export const ReferenceProperty = core.serialization
    .object({
    config: ReferencePropertyConfig,
})
    .extend(BaseProperty)
    .extend(ArrayableProperty);
